import React from "react";

const GoogleIcon = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5375 7.325H7.65994V9.3725H12.5425C12.295 12.23 9.91745 13.4525 7.66744 13.4525C4.79494 13.4525 2.27493 11.1875 2.27493 8C2.27493 4.925 4.67494 2.5475 7.67494 2.5475C9.99245 2.5475 11.35 4.025 11.35 4.025L12.775 2.54C12.775 2.54 10.945 0.5 7.59994 0.5C3.33993 0.5 0.0474243 4.1 0.0474243 8C0.0474243 11.7875 3.14493 15.5 7.71244 15.5C11.725 15.5 14.65 12.7475 14.65 8.6825C14.65 7.82 14.5375 7.325 14.5375 7.325Z" fill="currentColor"/>
    </svg>
  );
};

export default GoogleIcon;
